import { render, staticRenderFns } from "./ctcDetailsCard.vue?vue&type=template&id=446e2bb8&scoped=true"
import script from "./ctcDetailsCard.vue?vue&type=script&lang=js"
export * from "./ctcDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./ctcDetailsCard.vue?vue&type=style&index=0&id=446e2bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446e2bb8",
  null
  
)

export default component.exports